import "./hero.css";
import React, { useState, useEffect } from "react";

import img1 from "../../images/image.jpg";
import img2 from "../../images/mohamed_safvan_vp.jpeg";

const images = [img1, img2];

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000); // change every 3 sec

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            Hello, I’m <br /> <span>Mohamed Safvan Vp</span>
          </h1>
          <p>
            I’m a <strong>Full Stack Developer and IoT Developer</strong>, graduated with a <strong>Bachelor of Science in Physics</strong>, crafting smart web applications and intelligent hardware systems.
            I’m passionate about building seamless digital experiences and robotics solutions that make a difference.
          </p>
          <button className="hero-button">Say Hello!</button>
        </div>

        <div className="hero-stats">
          <div className="stat">
            <h2>1 Y.</h2>
            <p>Experience</p>
          </div>
          <div className="stat">
            <h2>20+</h2>
            <p>Projects Completed</p>
          </div>
          <div className="stat">
            <h2>10</h2>
            <p>Happy Clients</p>
          </div>
        </div>
      </div>

      {/* Right Side Image */}
      <div className="hero-image">
        <img src={images[currentImage]} alt="Mohamed Safvan VP" />
      </div>
    </section>
  );
};

export default Hero;